<template>
  <div class="maps">
    <h2>Maps</h2>
    <div v-if="geolocationEnabled == true">
      <div id="map"></div>
    </div>
    <div v-else>
      <div v-if="geolocationError == 0">
        <p>Approximating your location</p>
        <div class="loader"></div>
      </div>
      <div v-else-if="geolocationError == 1">
        <p>Enable geolocation in your browser and device to use this feature.</p>
        <button v-on:click="getLocation">Retry</button>
      </div>
      <div v-else-if="geolocationError == 3">
        <p>Geolocation timed out. Perhaps geolocation isn't enabled on your device.</p>
        <button v-on:click="getLocation">Retry</button>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data: function() {
    return {
      geolocationEnabled: false,
      geolocationError: 0,
      userLocation: {
        latitude: 0,
        longitude: 0
      },
      accuracy: 0,
      getLocationOptions: {
        maximumAge: 0,
        timeout: 20000,
        enableHighAccuracy: false
      }
    };
  },
  mounted: function() {
    this.$nextTick(this.getLocation);
  },
  methods: {
    initMap: function() {
      var map = L.map("map").setView(
        [this.userLocation.latitude, this.userLocation.longitude],
        13
      );
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
      var marker = L.marker([
        this.userLocation.latitude,
        this.userLocation.longitude
      ]).addTo(map);
      marker
        .bindPopup(
          "This is your approximated location.<br><br>The red circle represents the area within which you are likely to be, with a 95% accuracy."
        )
        .openPopup();
      var circle = L.circle(
        [this.userLocation.latitude, this.userLocation.longitude],
        {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: this.accuracy
        }
      ).addTo(map);
      circle.bindPopup("You are 95% likely to be inside this circle.");
      setTimeout(function() {
        map.fitBounds(circle.getBounds());
      }, 50);
    },
    getLocation: function() {
      this.geolocationError = 0;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.getLocationCallback,
          this.getLocationError,
          this.getLocationOptions
        );
      } else {
        this.geolocationEnabled = false;
      }
    },
    getLocationCallback: function(position) {
      this.userLocation.latitude = position.coords.latitude;
      this.userLocation.longitude = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.geolocationEnabled = true;
      this.$nextTick(this.initMap);
    },
    getLocationError: function(error) {
      this.geolocationEnabled = false;
      this.geolocationError = error.code;
    }
  }
};
</script>

<style scoped>
h2 {
  padding-top: 20px;
  font-weight: normal;
}

.leaflet-container {
  height: 500px;
}

.loader {
  margin: auto;
  width: 50%;
  border: 16px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
